<template>
  <div class="header">
    <header>
      <router-link to="/" class="logo" @click.native="logoClick">
        <img src="@/assets/images/logo.png" alt />
        <span>{{ logo_name }}</span>
      </router-link>
      <div class="nav">
        <a href="/" :class="$route.path == '/' ? 'active' : ''">Home</a>
        <a
          v-for="(item, index) in nav"
          :key="item.id"
          @click.stop="navClick(index)"
          :class="$route.path == item.path ? 'active' : ''"
        >
          {{ item.name }}
        </a>
        <a class="btn" href="https://play.google.com/store/apps/details?id=com.spicy.chat.lover.app" target="_blank">Download</a>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  data() {
    let d = this.$store.state.data;
    return {
      isActive: -1,
      nav: [
        { id: 1, path: "/about", name: d.page[1].title },
        { id: 2, path: "/contact-us", name: d.page[2].title },
        // { id: 3, path: "/privacypolicy", name: d.page[3].title },
        // { id: 4, path: "/terms", name: d.page[4].title },
      ],
      logo_name: "",
      logo: "",
    };
  },
  created() {
    this.renderUI();
  },
  watch: {
    $route(newVal) {
      let p = newVal.path;
      if (p == "/") {
        this.isActive = -1;
      } else if (p == "/about") {
        this.isActive = 0;
      } else if (p == "/contact-us") {
        this.isActive = 1;
      }
    },
  },
  methods: {
    navClick(index) {
      if (index == 2 || index == 3) {
        let routeData = this.$router.resolve({
          path: this.nav[index].path,
        });
        window.open(routeData.href, "_blank");
      } else {
        if (this.isActive != index){
          let path = this.nav[index].path;
          this.$router.push(path);
          this.isActive = index;
        }
      }
    },
    logoClick() {
      this.isActive = -1;
    },
    renderUI() {
      const config = this.$store.state.data;
      // this.logo_name = config.name;
      this.logo_name = config.logo_name;
      // this.logo = `${config.baseUrl}images/logo.png`;
      this.logo = `${config.logo}`;
    },
  },
};
</script>

<style lang="less" scoped>
header {
  max-width: 100%;
  height: 61px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  background-color: white;
  .logo {
    display: flex;
    align-items: center;
    span {
      font-weight: 400;
      color: #262626;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;

      &:hover {
        color: #000;
      }
    }

    img {
      width: 34px;
      margin-right: 10px;
    }
  }
  a {
    position: relative;
    &:hover {
      color: #000;
    }
    &.active {
      &::after {
        content: "";
        width: 70px;
        height: 3px;
        background: rgb(49, 179, 118);
        border-radius: 3px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .nav {
    display: flex;
    align-items: center;
    a {
      margin-left: 26px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      line-height: 30px;
      color: #262626;
      cursor: pointer;
    }
  }
  .btn{
    position: relative;
    display: inline-block;
    font-weight: 500;
    color: #fff;
    text-align: center;
    border: 1px solid #fff;
    border-radius: 30px;
    padding: 0 14px;
    text-decoration: none;
    font-family: 'Poppins',sans-serif;
    transition: all 500ms ease;
    // background-color: transparent;
    height: 30px;
    line-height: 30px;
    font-size: 13px !important;
    cursor: pointer;
    &:hover{
      background-color: #00e793;
      border-color: #00e793;
      color: #fff !important;
    }
  }
}
</style>
